import { useDeleteCity } from "./api/deleteCity";
import { Button } from "reactstrap";


const DeleteCity = ({handleCloseModal, cityId}: DeleteCityProps)  => {
  
  const deleteCityMutation = useDeleteCity({ cityId});
  const handleSubmit = async (): Promise<void> => {
    deleteCityMutation.mutateAsync({ 
      cityId: cityId
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε την Πόλη;</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeleteCityProps{
  cityId: number;
  handleCloseModal: () => void;
}

export default DeleteCity;